/**
 * @file   src\mobile\components\Common\DeleteModal.js
 * @brief  This file is responsible for showing delete modal
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";

const DeleteModal = (props) => {
  const { show, handleConfirm, title, buttonText, onHide } = props;

  return (
    <Modal
      show={show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-custom-width"
    >
      <Modal.Body className="pt-32 pb-32">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        ></button>
        <h2 className="text-center f-size-24 mb-4 l-spacing">{title}</h2>

        <Row>
          <Col xl={12} className="">
            <div className="modal-btn-wrap flex-column">
              <Button
                variant=""
                className="btn btn-tertiary me-0 w-100 mb-3"
                onClick={onHide}
              >
                Cancel
              </Button>
              <Button
                variant=""
                className="btn btn-delete w-100"
                onClick={handleConfirm}
              >
                {buttonText}
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default DeleteModal;
